import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import { ApolloClient } from '@isyc-react/oc-api';
import { AuthProvider } from '@isyc-react/auth/modules/context';
import { NotificationHubProvider } from '@isyc-react/form/modules/context/notification-hub';
import { Router } from 'core/router';
import { ApolloMockProvider } from 'common-app/api/mocks/apollo';
import { FormCommonProvider } from '@isyc-react/form/modules/context/form-common';
import { FormSize } from '@isyc-react/form/view-model';
import './i18n/i18n';
import 'assets/css/font-montserrat.css';
import '@isyc-react/design/main';
import 'assets/scss/portal.scss';
import 'assets/scss/login.scss';
import 'core/theme/variables.scss';
import { Spinner } from '@isyc-react/design/bootstrap';
import { NotificationToastifyProvider, PositionNotification } from '@isyc-react/form/modules/context';
const SuspenseRouter = () => (React.createElement(React.Suspense, { fallback: React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'd-flex align-items-center justify-content-center h-100' },
            React.createElement(Spinner, { animation: 'border', size: 'sm' }))) },
    React.createElement(AuthProvider, { checkLoggedIn: true },
        React.createElement(NotificationToastifyProvider, { position: PositionNotification.BOTTOM_RIGHT },
            React.createElement(NotificationHubProvider, null,
                React.createElement(FormCommonProvider, { size: FormSize.LG },
                    React.createElement(Router, null)))))));
const App = () => {
    if (process.env.NODE_ENV === 'development' && process.env.mocks === 'true') {
        return (React.createElement(ApolloMockProvider, null,
            React.createElement(SuspenseRouter, null)));
    }
    return (React.createElement(ApolloProvider, { client: ApolloClient },
        React.createElement(SuspenseRouter, null)));
};
ReactDOM.render(React.createElement(App, null), document.getElementById('root'));
